// extracted by mini-css-extract-plugin
var _1 = "tjs-filter-section__filter";
var _2 = "tjs-filter-section__filters tjs-_base__clearfix";
export { _1 as "filter", _2 as "filters" }
export default { "filter": _1, "filters": _2 }
